import { Colors } from '../styles/theme'
import { BadgeColor } from '@/ui'

export const CATEGORY_BADGE_COLORS: BadgeColor[] = [
  'olive',
  'blue',
  'purple',
  'pink',
  'gray',
]

export interface CategoryBadgeStyle {
  color: BadgeColor
  variant: 'default' | 'secondary'
}

// Both variants of each hue, so a category can land on the muted (secondary)
// or filled (default) look. Doubles the palette vs. one variant alone,
// trading fewer color collisions for some categories reading bolder than others.
const CATEGORY_BADGE_STYLES: CategoryBadgeStyle[] = [
  ...CATEGORY_BADGE_COLORS.map((color) => ({
    color,
    variant: 'secondary' as const,
  })),
  ...CATEGORY_BADGE_COLORS.map((color) => ({
    color,
    variant: 'default' as const,
  })),
]

// djb2 string hash. Used instead of hashing the numeric category id directly,
// since two category ids that differ by a multiple of CATEGORY_BADGE_STYLES.length
// would otherwise always collide onto the same style.
const hashString = (value: string): number => {
  let hash = 0
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

// The highest-volume categories account-wide (per Looker's customer_transactions
// export, 2026-09-02), in descending order. These get one dedicated muted hue
// each so the categories seen most often stay calm; this is a static snapshot
// rather than something computed from the current report, since relative
// category volume doesn't shift enough to need live ranking.
const TOP_VOLUME_CATEGORY_NAMES = [
  'Therapy Income',
  'Software Services',
  'Office Expenses',
  'Meals & Entertainment',
  'Advertising and Marketing',
]

export const getCategoryBadgeStyle = (
  categoryKey: string
): CategoryBadgeStyle => {
  const topVolumeIndex = TOP_VOLUME_CATEGORY_NAMES.indexOf(categoryKey)
  if (topVolumeIndex !== -1) {
    return {
      color: CATEGORY_BADGE_COLORS[topVolumeIndex],
      variant: 'secondary',
    }
  }
  return CATEGORY_BADGE_STYLES[
    hashString(categoryKey) % CATEGORY_BADGE_STYLES.length
  ]
}

export const BRIGHT_COLORS = [
  Colors.blue,
  Colors.purple,
  Colors.red,
  Colors.magenta,
  Colors.orange,
  Colors.yellow,
  Colors.accentGreen,
  Colors.teal,
]
export const USER_DOCUMENT_COLORS = [
  Colors.lightBlue,
  Colors.lightPurple,
  Colors.lightRed,
  Colors.lightMagenta,
  Colors.orange,
  Colors.lightYellow,
  Colors.lightGreen,
  Colors.lightTeal,
]
